import { Reveal } from "@/components/Reveal";
import { SplitText } from "@/components/liquid/SplitText";

export const LiquidPageHeader = ({ index, eyebrow, title, subtitle, testid }) => (
  <div className="relative">
    <div className="flex items-start justify-between gap-6">
      <div className="max-w-3xl">
        <Reveal>
          <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-[#1A1A1A]/50">{eyebrow}</p>
        </Reveal>
        <h1 className="mt-6 font-display text-[clamp(3rem,8vw,7rem)] font-normal leading-[0.95] tracking-tight text-[#1A1A1A]">
          <SplitText text={title} delay={0.2} testid={testid} />
        </h1>
        {subtitle && (
          <Reveal delay={0.5}>
            <p className="mt-6 max-w-xl text-sm font-light leading-relaxed text-[#1A1A1A]/60 sm:text-base">{subtitle}</p>
          </Reveal>
        )}
      </div>
      <Reveal delay={0.3} className="hidden shrink-0 lg:block">
        <span className="font-display text-7xl italic text-[#D4AF37]/60" aria-hidden="true">{index}</span>
      </Reveal>
    </div>
    <Reveal delay={0.4}>
      <div className="mt-10 h-px w-full bg-[#1A1A1A]/10" aria-hidden="true" />
    </Reveal>
  </div>
);
